
export type CollaboratorState = string[];

export const initialState: CollaboratorState = [] as CollaboratorState;
